import PropTypes from 'prop-types';
import React from 'react';

import { ActionMenuButton } from './styles';
import messages from './Messages';
import Dropdown from 'components/Dropdown';
import Icon from 'components/Icon';
import { createNewTag } from 'store/providers/providerSlice';

const { Menu, MenuItem, MenuDivider } = Dropdown;
class TagHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changeLimitation: false,
      openMoreProps: true,
    };
  }

  handleCreatingNewTag(e, parentId) {
    e.preventDefault();
    this.props.dispatch(
      createNewTag({ providerId: this.props.providerId, parentId: parentId })
    );
  }
  toggleDeleted = () => {
    this.props.setShowDeletedTags(!this.props.showDeletedTags);
  };

  handleOpenMorePropsChange = (newVal) => {
    this.setState({ openMoreProps: newVal });
  };

  render() {
    const { item, readOnly } = this.props;
    const actionWidth = '48px';
    return (
      <div>
        <nav className="z-depth-0">
          <div className="nav-wrapper">
            <ul
              className="right"
              style={{ maxWidth: 'calc(100% - ' + actionWidth + ')' }}
            >
              <li style={{ height: '45px' }}>
                <span className="text">
                  {item.parentId === null && !item.text ? (
                    <Icon type={'home'} />
                  ) : (
                    item.text
                  )}
                </span>
              </li>
            </ul>
            <ul style={{ position: 'absolute', left: 0 }}>
              {!readOnly && (
                <li>
                  <Dropdown
                    marginToTarget={0}
                    placement="bottom-start"
                    width={200}
                    target={
                      <ActionMenuButton>
                        <Icon type="plus-circle" />
                      </ActionMenuButton>
                    }
                  >
                    <Menu>
                      <MenuItem>
                        <a
                          href="#!"
                          onClick={(e) => this.handleCreatingNewTag(e, item.id)}
                        >
                          {messages.addTag}
                        </a>
                      </MenuItem>
                      <MenuDivider />
                    </Menu>
                  </Dropdown>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

TagHeader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  setShowDeletedTags: PropTypes.func.isRequired,
  showDeletedTags: PropTypes.bool.isRequired,
  providerId: PropTypes.number.isRequired,
};

export default TagHeader;
